import { ElementShownAnchor } from '@hh.ru/analytics-js';
import resumeKeySkillVacancyMatchElementShown, {
    HhtmSource,
} from '@hh.ru/analytics-js-events/build/xhh/employer/resume/resume_key_skill_vacancy_match_element_shown';
import { Tag } from '@hh.ru/magritte-ui';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';
import { formatToReactComponent } from 'bloko/common/trl';

import translation from 'src/components/translation';

import IconCirclePercent from 'src/components/ResumeCard/Header/Tags/IconCirclePercent';

import styles from './index.less';

const TrlKeys = {
    percentage: 'label.skillsPercentage',
};

export interface SkillsMatchedProps {
    hhtmSource: HhtmSource;
    resumeId: number;
    vacancyId: number;
    matchedKeySkillPercent: number;
}

const dataQa = 'resume-search-skills-matching';

const SkillsMatched: TranslatedComponent<SkillsMatchedProps> = ({ trls, ...skillsMatchedProps }) => {
    return (
        <ElementShownAnchor fn={resumeKeySkillVacancyMatchElementShown} {...skillsMatchedProps}>
            <Tag style="positive" data-qa={dataQa}>
                <span className={styles.tagSkillsMatchedWrapper}>
                    <IconCirclePercent percent={skillsMatchedProps.matchedKeySkillPercent} />
                    {formatToReactComponent(trls[TrlKeys.percentage], {
                        '{0}': <strong>{skillsMatchedProps.matchedKeySkillPercent}</strong>,
                    })}
                </span>
            </Tag>
        </ElementShownAnchor>
    );
};

export default translation(SkillsMatched);
